<template>
  <div
    :grc_placeholder="placeholder"
    :grc_labeltext="labeltext"
    :grc_labelmode="labelmode"
    :grc_labelwidth="labelwidth"
    :grc_readonly="readonly"    

    :grc_dropdownminwidth="settings.dropdownminwidth"
    :grc_dropdownmaxwidth="settings.dropdownmaxwidth"
    :grc_dropdownheight="settings.dropdownheight"
    :grc_dropdownpos="settings.dropdownpos"

    :grc_keyfield="keyfield"
    :grc_displayfield="displayfield"

    :grc_drpodown_columns="dropdown_columns"

    :value="component_value"
  >
    <div ref="comp_container" :class="['grccomp_container', labelmode=='table' ? 'grccomp_container_tablemode' : '']">
      <div ref="container_label" 
        :class="['grccomp_container_label', labelmode=='nolabel' ? 'grccomp_container_nolabel' : '', comp_focused ? 'grccomp_container_label_focused' : '']"
        v-bind:style="{ 'width': labelwidth }"
      >{{labeltext}}</div>
      <div ref="container_input" class="grccomp_container_input">
        <input ref="textinput" type="text" class="grc-combo-hiddentext" inputmode="none"
        v-model="display_text" 
        @input="onInput" 
        @blur="onInputBlur" 
        @focus="onInputFocus($event)" 
        @keydown="onInputKeydown"
        :readonly="readonly == 'true'"
        v-bind:placeholder="placeholder" />

        <span ref="combotext" :class="['grc-combo-label', comp_focused ? 'grc-combo-label-focused' : '', readonly=='true' ? 'grc-combo-label-read-only' : '']"
          @click="OpenDropdown">
          {{combotext}}
        </span>

        <span 
          :class="['fas','fa-chevron-down', labelmode=='above' ? 'grc-input-dropdown-icon-labelabove' : labelmode=='nolabel' ? 'grc-input-dropdown-icon-nolabel' : 'grc-input-dropdown-icon-labelleft']"
          @click="OpenDropdown"
        />
      </div>
    </div>

    <div ref="dropdown_cont_layer" class="grc_dropdown_fullscreen_layer" style="background-color:rgba(100,100,100,0.2);" v-show="dropdown_opened>0" 
      @click="CloseDropdown" @keydown="onLayerKeydown" 
       >
      <resize-observer @notify="onLayerResize" />
      <div ref="dropdown_cont" class="grc-input-dropdown-cont" 
        v-bind:style="{ 'left': dropdown_left, 'top': dropdown_top, 'width':settings.dropdownwidth+'px', 'height':settings.dropdownheight+'px' }" 
        @click="DropdownCont_click($event)"
      >
        <div ref="dropdown_proxy" tabindex="-1" class="grc_focus_proxy" @click="FocusProxy" @mouseup="FocusTextinput_dd" 
        >
          
          <input ref="textinput_dd" type="text" class="grc-combo-hiddentext" inputmode="none"
          v-model="display_text_dd" 
          @keydown="onInputKeydown_dd"
          />

          <table ref="grc_combo_table" class="grc-combo-table">
             <tr  v-for="(tr, index) in DataSource"
             :class="['grc-combo-tr', index==selectedindex ? 'grc-combo-tr-selected' : '']"
             @click="DropdownLineClick(index)"
             >
                <td 
                :class="['grc-combo-td', cols.cutlongtext=='true' ? 'grc-combo-td-cutlongtext' : '']"
                v-for="cols in dropdown_columns"
                v-bind:style="{'width':cols.width}"
                >
                  {{tr[cols.fieldname]}}
                </td>
            </tr>
          </table>

        </div>
      </div>
    </div>

    <GrcCompErrorBubble ref="ErrorBubble" />
  </div>
</template>

<script>

import Vue from 'vue'
import { setTimeout } from 'timers';
import { clearTimeout } from 'timers';
import GrcCompErrorBubble from '../GrcComponents/GrcCompErrorBubble.vue'


export default {
  name: 'GrcCombo',
  components:
  {
    GrcCompErrorBubble
  },
  props: {
    value: Number,
    grc_placeholder: String,
    grc_labeltext: String,
    grc_labelmode: String,
    grc_labelwidth: String,
    grc_readonly: String,    

    grc_dropdownminwidth: String,
    grc_dropdownmaxwidth: String,
    grc_dropdownheight: String,
    grc_dropdownpos: String,

    grc_keyfield: String,
    grc_displayfield: String,

    grc_dropdown_columns:Array

  },
  data () {
    return {
        component_value: -1,
        prev_component_value: -1,

        display_text: "",
        prev_display_text: "",         

        display_text_dd: "",
        prev_display_text_dd: "",         


        placeholder: this.grc_placeholder,
        labeltext: this.grc_labeltext,
        labelmode: this.grc_labelmode,
        labelwidth: this.grc_labelwidth,
        readonly: this.grc_readonly,

        comp_focused: false,
        settings: { dropdownwidth: 100, dropdownheight: this.grc_dropdownheight, 
        dropdownminwidth:this.grc_dropdownminwidth, dropdownmaxwidth:this.grc_dropdownmaxwidth, dropdownpos: this.grc_dropdownpos },

        dropdown_opened: 0,
        dropdown_left: "0px",
        dropdown_top: "0px",
        dropdown_value:"",
        dropdown_lastscrolltop:0,

        combotext:"",
        timeoutref1:null,
        selectedindex:-1,

        comp_focused_dd: false,
        timeoutref2:null,       

        DataSource: [],

        keyfield: this.grc_keyfield,
        displayfield: this.grc_displayfield,

        dropdown_columns:this.grc_dropdown_columns,

        lastlayerwidth:0,

        touch_Y:-1,

    }
  },
  watch : {
    value (pNewValue) {
      if (pNewValue !== this.prev_component_value) {
          this.prev_component_value = pNewValue;
          this.component_value = pNewValue;
          this.DisplayValue(pNewValue);
      }
    },

    selectedindex()
    {
      var s = "";
      //console.log("si: "+this.selectedindex);
      if (this.selectedindex>=0)
      {
        if (this.dropdown_opened == 0)
        {
          this.BroadcastInnerIndex();
          
        }

        if (this.selectedindex < this.DataSource.length)
        {
          s = this.DataSource[this.selectedindex][this.displayfield];
        }
      }
      else
      {
        s = "";
      }

      this.combotext = s;
    },


    display_text(pNewValue)
    {
        clearTimeout(this.timeoutref1);
        if (this.comp_focused == false) { return; }


        if (pNewValue != this.prev_display_text)
        {
            this.prev_display_text = pNewValue;
            this.display_text = pNewValue;
            
            if (this.display_text != "")
            {
                var i = this.SetIndexByText(this.display_text);
            }

          this.timeoutref1 = setTimeout(this.ClearSearchText1 ,500);        
        }
    },

    dropdown_value()
    {
      this.display_text = this.dropdown_value;
    },

    display_text_dd(pNewValue)
    {
        clearTimeout(this.timeoutref2);
        if (this.dropdown_opened == 0) { return; }


        if (pNewValue != this.prev_display_text_dd)
        {
            this.prev_display_text_dd = pNewValue;
            this.display_text_dd = pNewValue;
            
            if (this.display_text_dd != "")
            {
                var i = this.SetIndexByText(this.display_text_dd);
                //this.dropdown_lastscrolltop = 0;
                this.ScrollToSelectedLine(0);
            }

          this.timeoutref2 = setTimeout(this.ClearSearchText2 ,500);        
        }
    }

  },

  created: function()
  {
    if (typeof this.labelmode == "undefined")
    {
      this.labelmode = "nolabel";
    }

    var labelmodes = ["table", "above", "nolabel"];
    if (labelmodes.includes(this.labelmode) == false)
    {
      this.labelmode = "above";
    }

    if (typeof this.labelwidth == "undefined")
    {
      this.labelwidth = "";
    }


    var ddpos = ["left", "right"];
    if (ddpos.includes(this.settings.dropdownpos) == false)
    {
      this.settings.dropdownpos = "left";
    }


    this.ValidateDropdownSize();


    if (typeof this.placeholder == "undefined")
    {
      this.placeholder = "";
    }

    if (typeof this.value == "undefined")
    {
      this.value = -1;
    }

    this.prev_component_value = this.value;
    this.component_value = this.value;
    this.DisplayValue(this.component_value);
  },
  computed: {
    
  },
  methods: {

    SetLabel(pText)
    {
      this.labeltext = pText;
    },

    ShowError(pText)
    {
      this.$refs.ErrorBubble.ShowError(pText);
    },

    HideError()
    {
      this.$refs.ErrorBubble.HideError();
    },


    onLayerResize()
    {
      var layerpos = grccomp_findPos(this.$refs.dropdown_cont_layer);
      //console.log("opened: "+this.dropdown_opened+"  last: "+this.lastlayerwidth+"  currw: "+layerpos.width);
      if (this.dropdown_opened != 2) { return; }
      
      if (this.lastlayerwidth != layerpos.width)
      {
        this.CloseDropdown();
      }
    },

    ValidateDropdownSize()
    {
      if (typeof this.settings.dropdownminwidth == "undefined")
      {
        this.settings.dropdownminwidth = 0; //grccomp_GetDefaults_Combo().dropdownwidth;
      }

      if (typeof this.settings.dropdownmaxwidth == "undefined")
      {
        this.settings.dropdownmaxwidth = 0; //grccomp_GetDefaults_Combo().dropdownwidth;
      }

      if (typeof this.settings.dropdownheight == "undefined")
      {
        this.settings.dropdownheight = grccomp_GetDefaults_Combo().dropdownheight;
      }

    },

    DisplayValue(pNewValule)
    {
        var s = "";
        var si = -1;
        for(var i=0; i<this.DataSource.length;i++)
        {
            if (this.DataSource[i][this.keyfield] == pNewValule)
            {
              s = this.DataSource[i][this.displayfield];
              si = i;
              break;
            }
        }


        this.selectedindex = si;
        this.combotext = s;
    },

    CheckText: function(pText)
    {
      var CheckOK = true;
      
      return CheckOK;
    },

    FormatText: function(pText)
    {
      if (pText == null) { pText = ""; }
      var res = pText;

      return res;
    },

    onInputBlur()
    {
      this.comp_focused = false;
      var v = this.prev_component_value;
      if (this.selectedindex>=0 && this.selectedindex<this.DataSource.length)
      {
        v = this.DataSource[this.selectedindex][this.keyfield];
      }
      var ValueChanged = (v != this.prev_component_value);

      this.component_value = v;

      if (ValueChanged)
      {
        this.$emit('valuechanged', this.component_value);
      }

      this.prev_component_value = this.component_value;

      this.$emit('grc-blur');
    },

    onInput (e) {
      //if (e.isTrusted) { return; } // ignore native event
    },

    onLayerKeydown(e)
    {
      //return;
      //console.log(e.keyCode);
      //console.log("agent: "+grcmain_GetAgent());

      if (e.keyCode == 27)
      {
        
        if (grcmain_GetAgent() == "EDGE")
        {
          e.stopPropagation();
          e.preventDefault();
          return;
        }
        
        this.CloseDropdown();
        e.stopPropagation();
        e.preventDefault();
        
      }
    },

    onInputKeydown(e)
    {
      //console.log(e.keyCode);

      if ((e.keyCode == 13) || (e.keyCode == 9)) {}
      else
      {
        this.$refs.ErrorBubble.HideError();
      }


      var noprop = [40,38,33,34,35,36];
      if (noprop.includes(e.keyCode)) { e.stopPropagation(); e.preventDefault(); }

      this.$emit('grc-keydown', e.keyCode);
      if (e.keyCode == 13)
      {
        this.$emit('grc-keydown-enter');
        return;
      }

      if (e.keyCode == 40) // down
      {
        if (this.selectedindex < this.DataSource.length-1) 
        {
          this.selectedindex = this.selectedindex + 1;
        }
        return;
      }

      if (e.keyCode == 38) // up
      {
        if (this.selectedindex > 0) 
        {
          this.selectedindex = this.selectedindex - 1;
        }
        return;
      }

      if (e.keyCode == 34) // page down
      {
        this.OpenDropdown();
        return;
      }

      if (e.keyCode == 46) // del
      {
        if (this.IsReadonly()) { return; }

        this.SetValue(0);
        return;
      }


    },

    onInputFocus(e)
    {
      this.comp_focused = true;
      //this.DisplayValue(this.component_value);
        Vue.nextTick(function () {
            e.target.select();
        });      
      this.$emit('grc-focus');
    },

    SetFocus()
    {
      this.$refs.textinput.focus();
    },

    SetReadonly(pReadonly)
    {
      if (pReadonly == true)
      {
        this.readonly = "true";
      }
      else
      {
        this.readonly = "false";
      }
    },

    IsReadonly()
    {
      return (this.readonly == "true");
    },

    OpenDropdown()
    {
      if (this.dropdown_opened > 0) { this.dropdown_opened = 0; return; }
      if (this.readonly == "true") 
      { 
        this.$refs.textinput.focus();
        return; 
      }
      grcmain_SetBodyScrollable(false);

      var bodysize = grccomp_getBodySize();

      var elpos = grccomp_findPos(this.$refs.combotext);

      var ch = parseInt(this.settings.dropdownheight);

      var cw = elpos.width;// parseInt(this.settings.dropdownwidth);      
      if (cw <parseInt(this.settings.dropdownminwidth)) { cw = parseInt(this.settings.dropdownminwidth); }
      if ((parseInt(this.settings.dropdownmaxwidth) > 0) && (cw >parseInt(this.settings.dropdownmaxwidth)))
      {
        cw = parseInt(this.settings.dropdownmaxwidth);
      }

      this.settings.dropdownwidth = cw;

      elpos.top = elpos.top - bodysize.scrollTop;
      //console.log("body scrolltop: "+bodysize.scrollTop);

      var screensize = grccomp_getScreenSize();
      

      //if (elpos.top + elpos.height + ch <= bodysize.height)
      if (elpos.top + elpos.height + ch <= screensize.height -40) // android chrome header -40
      {
        elpos.top = elpos.top + elpos.height;
      }
      else
      {
        elpos.top = elpos.top - ch - 8;
      }

      if (elpos.top < 0) { elpos.top = 0; }


      if (this.settings.dropdownpos == "left")
      {
        if (elpos.left+cw > bodysize.width -5)
        {
          var x = bodysize.width -5 - cw;
          if (x<5) { x = 5; }
          elpos.left = x;
        }
      }
      else
      {
        elpos.left = elpos.left + elpos.width - cw;
        if (elpos.left < 5) { elpos.left = 5; }
      }


      this.lastlayerwidth = 0;

      this.dropdown_left = ""+elpos.left+"px";
      this.dropdown_top = ""+elpos.top+"px";

      this.dropdown_value = this.display_text;
      this.dropdown_opened = 1;

      
      this.$emit("dropdownopened");
    },

    CloseDropdown()
    {
      grcmain_SetBodyScrollable(true);
      this.$emit("dropdownclosed");
      this.dropdown_opened = 0;
      this.BroadcastInnerIndex();

      this.$refs.textinput.focus();

    },

    BroadcastInnerIndex()
    {
      this.$emit("innerindexbroadcast", this.selectedindex);
      this.HideError();
    },

    DropdownCont_click(e)
    {
      e.preventDefault();
      e.stopPropagation();
    },

    FocusProxy()
    {
      this.$refs.dropdown_proxy.focus();
    },


    SetIndexByText(pText)
    {
      pText = pText.toLowerCase();
      var ind = -1;
      for(var i=0; i<this.DataSource.length; i++)
      {
        if (this.DataSource[i][this.displayfield].toLowerCase().startsWith(pText))
        {
          if (ind < 0) { ind = i; break; }
        }
      }

      if (ind < 0) { ind = 0; }
      this.selectedindex = ind;

      return ind;
    },

    ClearSearchText1()
    {
      this.display_text = "";
    },

    ClearSearchText2()
    {
      this.display_text_dd = "";
    },

    DropdownLineClick(pIndex)
    {
      this.selectedindex = pIndex;
      this.CloseDropdown();
    },

    onInputKeydown_dd(e)
    {
      var noprop = [40,38,33,34,35,36];
      if (noprop.includes(e.keyCode)) { e.stopPropagation(); e.preventDefault(); }

      this.$emit('grc-keydown', e.keyCode);
      if (e.keyCode == 13)
      {
        this.CloseDropdown();
        return;
      }

      /*
      if (e.keyCode == 27)
      {
        this.CloseDropdown();
        return;
      }
      */

      var scrolldir = 1;

      if (e.keyCode == 40) // down
      {
        if (this.selectedindex < this.DataSource.length-1) 
        {
          this.selectedindex = this.selectedindex + 1;
          scrolldir = 1;
        }
        else { return; }
      }

      if (e.keyCode == 38) // up
      {
        if (this.selectedindex > 0) 
        {
          this.selectedindex = this.selectedindex - 1;
          scrolldir = -1;
        }
        else { return; }
      }

      if (e.keyCode == 34)
      {
        if (this.selectedindex + 10 < this.DataSource.length)
        {
          this.selectedindex = this.selectedindex + 10;
        }
        else
        {
          this.selectedindex = this.DataSource.length - 1;
        }
        scrolldir = 1;
      }

      if (e.keyCode == 33)
      {
        if (this.selectedindex - 10 > 0)
        {
          this.selectedindex = this.selectedindex - 10;
        }
        else
        {
          this.selectedindex = 0;
        }
        scrolldir = -1;
      }

      this.ScrollToSelectedLine(scrolldir);

    },

    FocusTextinput_dd()
    {
      this.$refs.textinput_dd.focus();
    },

    ScrollToSelectedLine(pDir) // -1: up, 0: mostup, 1:down
    {
        var top = 0;
        if ((this.selectedindex < 0) || (this.DataSource.length == 0)) 
        {
          this.dropdown_lastscrolltop = top;
          this.$refs.dropdown_proxy.scrollTop = top;
          return;
        }

        

        var contpos = grccomp_findPos(this.$refs.dropdown_proxy);
        var tablepos = grccomp_findPos(this.$refs.grc_combo_table);
        var elpos = grccomp_findPos(this.$refs.grc_combo_table.children[this.selectedindex]);
        elpos.top = elpos.top - tablepos.top;


        if (pDir == 1) // down
        {
          if (elpos.top + elpos.height - this.dropdown_lastscrolltop > contpos.height)
          {
            top = elpos.top + elpos.height - contpos.height;  
            this.dropdown_lastscrolltop = top;
          }
          else
          {
            top = this.dropdown_lastscrolltop;
          }
          
        }

        if (pDir == -1)
        {
          if (elpos.top < this.dropdown_lastscrolltop)
          {
            top = elpos.top;
            if (top<0) { top = 0; }
            this.dropdown_lastscrolltop = top;
          }
          else
          {
            top = this.dropdown_lastscrolltop;
          }
        }

        
        if (pDir == 0)
        {
          top = elpos.top;
          this.dropdown_lastscrolltop = top;
        }
        


        
        this.$refs.dropdown_proxy.scrollTop = top;
    },

    SetDataSource(pDataSource)
    {
        this.DataSource = pDataSource;      
        this.selectedindex = -1;
        this.prev_component_value = -1;
        this.component_value = -1;
    },

    SetValue(pValue)
    {
      this.HideError();

      this.component_value = pValue;
      
      this.DisplayValue(this.component_value);
      this.$emit('input', this.component_value);
    },

    GetValue()
    {
      return this.component_value;
    },

    GetText()
    {
      return this.combotext;
    }


    
  },

  updated: function()
  {
    this.$nextTick(function () {
      if (this.dropdown_opened == 1)
      {
        var layerpos = grccomp_findPos(this.$refs.dropdown_cont_layer);
        this.lastlayerwidth = layerpos.width;

        this.dropdown_opened = 2;
        this.prev_display_text_dd = "";
        this.display_text_dd = "";
        this.$refs.textinput_dd.focus();
        this.ScrollToSelectedLine(0);
      }
    });
  }
}
</script>

<style scoped>


</style>